module.exports = __webpack_public_path__ + "img/1.321f39e9.jpg";